var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "21px",
    height: "20.002px",
    viewBox: "76.542 150.556 21 20.002",
    enableBackground: "new 76.542 150.556 21 20.002",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#01B455",
    d: "M87.019,150.556c0.738,0.031,1.261,0.371,1.585,1.027 c0.693,1.402,1.4,2.797,2.083,4.205c0.142,0.291,0.329,0.419,0.649,0.461c1.545,0.206,3.087,0.432,4.63,0.653 c0.718,0.103,1.255,0.459,1.482,1.16c0.231,0.712,0.028,1.325-0.513,1.844c-1.123,1.076-2.229,2.169-3.359,3.237 c-0.241,0.228-0.294,0.45-0.238,0.758c0.269,1.479,0.521,2.96,0.783,4.439c0.133,0.75,0.012,1.42-0.648,1.889 c-0.653,0.463-1.321,0.392-2.006,0.025c-1.318-0.707-2.656-1.377-3.971-2.089c-0.335-0.182-0.593-0.167-0.919,0.009 c-1.331,0.715-2.679,1.397-4.013,2.105c-0.656,0.348-1.3,0.402-1.927-0.029c-0.646-0.444-0.817-1.082-0.686-1.826 c0.263-1.494,0.511-2.992,0.787-4.484c0.064-0.347-0.004-0.586-0.268-0.834c-1.109-1.047-2.19-2.121-3.294-3.174 c-0.554-0.529-0.779-1.145-0.537-1.877c0.238-0.721,0.799-1.059,1.533-1.161c1.543-0.215,3.086-0.441,4.63-0.649 c0.289-0.039,0.452-0.17,0.577-0.426c0.693-1.42,1.401-2.83,2.102-4.246C85.795,150.935,86.308,150.6,87.019,150.556z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar01);
export default __webpack_public_path__ + "static/media/star-01.91a6446ddb5390e258d8b4cef1cf2976.svg";
export { ForwardRef as ReactComponent };